import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./service-management-requirement.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service-management-requirement.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";
import {
  addServiceRequirementAlternativeMutation,
  getServiceManagementRequirements
} from "./service-management-requirement.actions";



@Injectable()
export class ServiceManagementRequirementEffects {
  createServiceManagementRequirement$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceManagementRequirements),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_SERVICE_MANAGEMENT_REQUIREMENT,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {
          console.log('effect', action.input)
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceManagementRequirements({ serviceManagementRequirements: result?.data }));
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  updateServiceRequirementDescriptionMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateServiceRequirementDescriptionMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_SERVICE_REQUIREMENT_DESCRIPTION,
        variables: {
          input: action?.input
        }
      })
        .pipe(
          this.notificationService.catchError('Problem occurred while updating record'),
          map(({ data }: any) => {
            if (data) {
              const result: any = Object.values(data)[0];
              if (result?.response?.code == '9000') {
                this.store.dispatch(
                  fromActions.upsertServiceManagementRequirement({ serviceManagementRequirement: result?.data })
                );
                this.notificationService.successMessage('Updated Successfully');
              }
              else {
                this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
              }
            }
          })
        );
    })
  ), { dispatch: false });


  addServiceRequirementAlternativeMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.addServiceRequirementAlternativeMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.ADD_SERVICE_REQUIREMENT_ALTERNATIVE,
        variables: {
          input: action?.input
        }
      })
        .pipe(
          this.notificationService.catchError('Problem occurred while updating record'),
          map(({ data }: any) => {
            if (data) {
              const result: any = Object.values(data)[0];
              if (result?.response?.code == '9000') {
                this.store.dispatch(
                  fromActions.upsertServiceManagementRequirement({ serviceManagementRequirement: result?.data })
                );
                this.notificationService.successMessage('Updated Successfully');
              }
              else {
                this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
              }
            }
          })
        );
    })
  ), { dispatch: false });


  removeServiceRequirementAlternativeMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServiceRequirementAlternativeMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.REMOVE_SERVICE_REQUIREMENT_ALTERNATIVE,
        variables: {
          requirementUniqueId: action?.requirementUniqueId
        }
      })
        .pipe(
          this.notificationService.catchError('Problem occurred while updating record'),
          map(({ data }: any) => {
            if (data) {
              const result: any = Object.values(data)[0];
              if (result?.response?.code == '9000') {
                this.store.dispatch(
                  fromActions.upsertServiceManagementRequirement({ serviceManagementRequirement: result?.data })
                );
                this.notificationService.successMessage('Removed Successfully');
              }
              else {
                this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
              }
            }
          })
        );
    })
  ), { dispatch: false });

  deleteServiceManagementRequirement$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServiceManagementRequirements),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_SERVICE_MANAGEMENT_REQUIREMENT,
        variables: {
          serviceRequirementUniqueId: action?.serviceRequirementUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServiceManagementRequirement({ id: action.id }));
              await this.notificationService.successMessage('Deleted Successfully');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceDeliveryDurations$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceManagementRequirements),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_SERVICE_MANAGEMENT_REQUIREMENT,
        fetchPolicy: 'network-only',
        variables: {
          serviceUniqueId: action.serviceUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service requirements'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceManagementRequirements({ serviceManagementRequirements: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
